import moment from "moment";

/**
 * Formats a date value into the `DD/MM/YYYY` format.
 *
 * @function formatDate
 * @param {string | Date | number | null | undefined} date - The date value to be formatted.
 * Accepts a Date object, a timestamp, or a date string compatible with Moment.js.
 * @returns {string} The formatted date string in `DD/MM/YYYY` format,
 * or an empty string if the date is null, undefined, or invalid.
 */
export const formatDate = (date) => {
  if (!date) return "";
  return moment(date).format("DD/MM/YYYY");
};
